import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationService} from '../common/services/notifications.service';
import {AreasService} from './services/areas.service';
import {DesenvolvedoresService} from './services/desenvolvedores.service';
import {ProdutosService} from './services/produtos.service';

@Component({
    selector: 'store-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

    @ViewChild('modalAdicionarProduto')
    private modalAdicionarProduto: any;

    @ViewChild('modalConfirmarRemocaoPublicacao')
    private modalConfirmarRemocaoPublicacao: any;

    @ViewChild('modalConfirmarExclusaoRascunho')
    private modalConfirmarExclusaoRascunho: any;

    hasToken: boolean;

    isLoading: boolean;

    accessToken = '';

    pageProducts: Array<any>;

    private plataformas: Array<any> = [
        {
            chave: 'WEB',
            valor: 'Cloud'
        },
        {
            chave: 'MOBILE',
            valor: 'Mobile'
        },
        {
            chave: 'EXTENSAO',
            valor: 'Extensão'
        }
    ];

    private areasNegocio: Array<any> = [];

    private desenvolvedores: Array<any> = [];

    productToRemove: any;

    product: any = {
        idLoja: null,
        utilizaLicenciamento: true,
        ativarLicenca: true,
        urlLicenca: 'https://betha.cloud/#/liberacoes/entidade',
        fazerDownload: false,
        urlDownload: null,
        emailDemonstracao: 'demonstracao@betha.com.br',
        baixarAppStore: false,
        urlAppStore: null,
        disponivelGooglePlay: false,
        urlGooglePlay: null,
        logo: '',
        areaNegocio: null,
        nome: '',
        descricao: '',
        imagem: '',
        plataforma: null,
        possuiHighlights: false,
        highlights: [],
        possuiVideo: false,
        descricaoVideo: '',
        urlVideo: '',
        possuiPowerNumbers: false,
        powerNumbers: [],
        possuiBeneficios: false,
        imagemBeneficio: '',
        beneficios: [],
        possuiMaisInformacoes: false,
        maisInformacoes: [],
        possuiCases: false,
        cases: [],
        possuiDepoimentos: false,
        depoimentos: [],
        possuiPerguntasFrequentes: false,
        perguntasFrequentes: [],
        desenvolvedor: null,
        ehMaisUtilizado: true,
        exibirHome: false,
        ehNovidade: false,
        possuiSeloBetha: false,
        numeroEstrelas: 4,
        compatibilidade: '',
        _internal: false
    };

    constructor(
        private productsService: ProdutosService,
        private modalService: NgbModal,
        private areasService: AreasService,
        private desenvolvedoresService: DesenvolvedoresService,
        private router: Router,
        private notificationService: NotificationService
    ) {
    }

    ngOnInit(): void {
        this.init();
    }

    private init(): void {
        const token: string = this.productsService.getToken();
        if (token && token.length) {
            this.createProductPage();
        } else {
            this.hasToken = false;
        }
    }

    createProductPage(): void {
        this.accessToken = this.productsService.getToken();
        this.hasToken = true;
        this.isLoading = true;
        this.loadProducts();
    }

    private initPlataformaSelect(): void {
        const listaPlataformas = [];
        const selectPlataforma: HTMLBthSelectElement = document.querySelector('bth-select[name=plataformaSelect]');
        this.plataformas.forEach(area => {
            listaPlataformas.push({
                id: area.chave,
                description: area.valor
            });
        });
        selectPlataforma.setOptions(listaPlataformas);
    }

    onChangePlataforma(event: any): void {
        this.product.plataforma = this.plataformas.find(plataforma => plataforma.chave === event.detail.value);
    }

    private getAreasNegocio(): void {
        this.areasService.getAll().then(result => {
            this.areasNegocio = result;
            this.initAreaSelect();
        });
    }

    private initAreaSelect(): void {
        const listaAreas = [];
        const selectArea: HTMLBthSelectElement = document.querySelector('bth-select[name=areaSelect]');
        this.areasNegocio.forEach(area => {
            listaAreas.push({
                id: area.id,
                description: area.descricao
            });
        });
        selectArea.setOptions(listaAreas);
    }

    onChangeArea(event: any): void {
        this.product.areaNegocio = this.areasNegocio.find(area => area.id === event.detail.value);
    }

    private getDesenvolvedores(): void {
        this.desenvolvedoresService.getAll().then(result => {
            this.desenvolvedores = result;
            this.initDesenvolvedoresSelect();
        });
    }

    private initDesenvolvedoresSelect(): void {
        const listaDesenvolvedores = [];
        const selectDesenvolvedor: HTMLBthSelectElement = document.querySelector('bth-select[name=desenvolvedorSelect]');
        this.desenvolvedores.forEach(desenvolvedor => {
            listaDesenvolvedores.push({
                id: desenvolvedor.id,
                description: desenvolvedor.nome
            });
        });
        selectDesenvolvedor.setOptions(listaDesenvolvedores);
    }

    onChangeDesenvolvedor(event: any): void {
        this.product.desenvolvedor = this.desenvolvedores.find(desenvolvedor => desenvolvedor.id === event.detail.value);
    }

    loadProducts(): void {
        this.pageProducts = new Array<any>();

        const drafts: Array<any> = this.productsService.getDrafts();

        this.productsService.getAll().then((result: Array<any>) => {
            this.isLoading = false;
            this.pageProducts = result;

            this.pageProducts.map(produto => produto.ehPublicado = true);
            drafts.forEach(draft => {
                this.pageProducts.unshift(draft);
            });

            this.pageProducts.sort((a, b) => (a.nome > b.nome) ? 1 : -1);
        }).catch(() => {
            this.isLoading = false;
        });
    }

    addProduct(): void {
        this.modalService.open(this.modalAdicionarProduto, {backdrop: 'static', size: 'lg'});

        this.getAreasNegocio();
        this.initPlataformaSelect();
        this.getDesenvolvedores();
    }

    validateAddProductForm(): boolean {
        return !(this.product.nome.length && this.product.plataforma && this.product.areaNegocio && this.product.desenvolvedor);
    }

    saveProduct(): void {
        this.product.idLoja = this.productsService.getDrafts().length + 1;
        this.productsService.setDraft(this.product);
        this.modalService.dismissAll();
        this.router.navigate(['./admin', this.product.idLoja, 'draft']);
    }

    removePublicationOrDraft(product: any): void {
        this.productToRemove = product;
        if (product.ehPublicado) {
            this.modalService.open(this.modalConfirmarRemocaoPublicacao, {backdrop: 'static'}).result.finally(() => {
                this.productToRemove = null;
            });
        } else {
            this.modalService.open(this.modalConfirmarExclusaoRascunho, {backdrop: 'static'}).result.finally(() => {
                this.productToRemove = null;
            });
        }
    }

    confirmPublicationRemoval(): void {
        const product: any = this.productToRemove;
        this.modalService.dismissAll();

        this.productsService.removePublication(product.idLoja).then(() => {
            product.ehPublicado = false;
            const drafts: Array<any> = this.productsService.getDrafts();
            const draft: any = drafts.find(rascunho => rascunho.idLoja === product.idLoja);
            if (draft) {
                this.productsService.deleteDraft(draft);
            }
            this.productsService.setDraft(product);
            this.notificationService.publish({type: 'success', description: 'Publicação removida com sucesso'});
            setTimeout(() => {
                this.loadProducts();
            }, 1000);
        });

    }

    confirmDraftRemoval(): void {
        this.productsService.deleteDraft(this.productToRemove);
        this.notificationService.publish({type: 'success', description: 'Rascunho excluído com sucesso'});
        this.loadProducts();
        this.modalService.dismissAll();
    }

    validateToken(): void {
        if (this.accessToken.length) {
            this.productsService.setToken(this.accessToken);
            this.createProductPage();
        }
    }

    removeToken(): void {
        this.accessToken = '';
        this.productsService.removeToken();
        this.init();
    }

}
